<template>
    <!-- 首页头部样式 -->
    <div class="header-top-container-bg"></div>
    <div class="header-top-container full-screen-container" v-bind="$attrs">
        <div class="main-container">
            <div class="flex-between content-wrap">
                <div class="left-container">
                    <span
                        class="name mr-20 black-font-color overflow-ellipsis"
                        :title="brandInfo?.siteName"
                        v-if="brandInfo?.siteName"
                        >欢迎来到{{ brandInfo?.siteName || '' }}
                    </span>
                    <span class="light-gray-font-color"
                        >本站支持IPv6访问</span
                    >
                </div>
                <div class="right-container">
                    <template v-if="!currentUser?.userId">
                        <span class="right-login pointer" @click="goLogin">{{
                            isRegist ? '登录/注册' : '登录'
                        }}</span>
                    </template>
                    <template v-else>
                        <!-- 消息 -->
                        <span
                            class="news-img-wrap pointer"
                            @click="goPage('myMessage')"
                        >
                            <div
                                class="has-message"
                                v-if="unreadMessageNum"
                            >  {{ unreadMessageNum }} </div>
                        </span>
                        <HeaderDrop
                            popperClass="user-drop-menu1"
                            :applications="applications"
                        ></HeaderDrop>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import {computed, ref, watch, inject} from 'vue';
import {useStore} from 'vuex';
import {pageJump} from '@/global/location-transfer';
import {getUrl} from '@/router/jumpHref.js';
import config from '@/global/config';
import {staticRoutes} from '@/router';
import HeaderDrop from '@/components/menu/part/header-drop';

const moocComName = inject('moocComName');

const store = useStore();

const registMap = computed(() => {
    let pagePermission = store.state?.pagePermission || {};
    let list =
        pagePermission['accountManage:loginAndRegist:isOpen']?.moduleRuleList ||
        [];
    let temp = {};
    list?.length &&
        list.forEach(element => {
            temp[element.ruleKey] = element.checked;
        });
    return temp;
});

const isRegist = computed(() => {
    return !registMap.value?.['0'];
});

// 获取当前用户信息
const currentUser = ref(null);
const username = computed(() => {
    return currentUser.value?.realName || currentUser.value?.name || '';
});

const unreadMessageNum = computed(() => {
    let num =
        store.state?.unreadMessage?.like + store.state?.unreadMessage?.message;

    if (+num == 0) {
        num = false;
    }
    if (+num > 99) {
        num = '99+';
    }

    return num;
});
// 监听个人信息变化
watch(
    () => store.state.currentUser,
    val => {
        currentUser.value = val;
        if (val.userId) {
            store.dispatch('user/getUnreadMessage');
            getApplicationList();
        }
    },
    {deep: true, immediate: true}
);
// 全部备案信息
const brand = computed(() => {
    return store.state.brand && store.state.brand.publishBrand
        ? store.state.brand.publishBrand
        : {};
});

const pagePermission = computed(() => {
    return store.state?.pagePermission || {};
});

const comName = computed(() => {
    return pagePermission.value?.coopgroup?.moduleNameAlias || pagePermission.value?.coopgroup?.moduleName || '协作组';
});

// 具体备案信息
const brandInfo = computed(() => {
    return brand.value.brandConfig ? brand.value.brandConfig : {};
});

function goLogin() {
    console.log('logout', 333)
    store.dispatch('logout');
}

function exit() {
    G_transmit('logout', {
    }).then(res => {
        store.dispatch('logoutHome');
    }).catch(error => {
        console.log(error);
    });
    
}

function goPage(name) {
    if (name === 'userHomePage' && !showPersonCenter.value) {
        return;
    }
    pageJump({name});
}

const goSelfUrl = str => {
    let url = getUrl(str);
    pageJump(url, '_blank');
};

const showManage = computed(() => {
    // 是否显示管理中心
    let pagePermission = store.state?.pagePermission || {};
    let isHaveIdmx = store.state.user?.isHaveIdmx;
    return !!pagePermission['manageCenter:base:home'] && isHaveIdmx;
});

const showPersonCenter = computed(() => {
    // 是否显示个人中心
    let pagePermission = store.state?.pagePermission || {};
    return !!pagePermission['personalCenter:page'];
});

const showStrain = computed(() => {
    // 是否显示培训管理系统
    let pagePermission = store.state?.pagePermission || {};
    let isHaveStrain = store.state.user?.isHaveStrain;
    return (
        !!pagePermission.continuingEducation &&
        !!pagePermission.train &&
        isHaveStrain
    );
});

const images = {
    'resourceApplication:my': require('@/assets/img/menu-icon/resource.png'),
    'coopgroup:my': require('@/assets/img/menu-icon/group.png'),
    'activity:my': require('@/assets/img/menu-icon/activity.png'),
    'train:my': require('@/assets/img/menu-icon/course.png'),
    'continuingEducation:my': require('@/assets/img/menu-icon/teach.png'),
    'video:my': require('@/assets/img/menu-icon/case.png'),
    'moocApplication:my': require('@/assets/img/menu-icon/mooc.png'),
    'material:my': require('@/assets/img/menu-icon/material.png'),
    'workshop:my': require('@/assets/img/menu-icon/studio.png'),
    'competition:my': require('@/assets/img/menu-icon/competition.png'),
    'research:my': require('@/assets/img/menu-icon/research.png'),
    'selection:my': require('@/assets/img/menu-icon/competition.png'),
    'expertstudio:my': require('@/assets/img/menu-icon/studio2.png'),
    'basicschool:my': require('@/assets/img/menu-icon/school.png'),
    'project:my': require('@/assets/img/menu-icon/subject.png'),
    'resultcultivation:my': require('@/assets/img/menu-icon/achievement.png'),
    'resultselection:my': require('@/assets/img/menu-icon/achievement-awards.png')
    // 'courseResource:my': require('@/assets/img/menu-icon/course-resource.png'),
    // 'continueEducation:my': require('@/assets/img/menu-icon/credit-space.png'),
};
const applications = ref([]);
// 获取应用
function getApplicationList() {
    G_transmit('getUserCenterLatestBrand', {
        name: 'getUserCenterLatestBrand'
    })
        .then(res => {
            const data = res?.data || [];
            let menuList = [];
            let tempMap = {};
            console.log('staticRoutes', staticRoutes);
            data.length &&
                data.forEach(item => {
                    if (
                        item.moduleKey &&
                        staticRoutes[item.moduleKey] &&
                        staticRoutes[item.moduleKey].name &&
                        !tempMap[item.moduleKey]
                    ) {
                        tempMap[item.moduleKey] = item;
                        let title = staticRoutes[item.moduleKey].title;
                        let shortTitle = staticRoutes[item.moduleKey].meta?.shortTitle;
                        if (item.moduleKey === 'coopgroup:my') {
                            title = comName.value;
                            shortTitle = comName.value;
                        } else if (item.moduleKey === 'moocApplication:my') {
                            title = moocComName;
                            shortTitle = moocComName;
                        }
                        let temp = {
                            path: staticRoutes[item.moduleKey].path,
                            id: item.moduleKey,
                            title: title,
                            shortTitle: shortTitle,
                            route: {name: staticRoutes[item.moduleKey].name},
                            isOther: false,
                            icon: images[item.moduleKey]
                        };
                        menuList.push(temp);
                    }
                });
            applications.value = menuList || [];
        })
        .catch(() => {});
}
</script>

<style lang="scss">
// .home-drop-menu {
//     .el-dropdown-menu__item {
//         justify-content: center;
//     }
// }
.user-drop-menu1 {
    top: 50px !important;
    width: 294px !important;
    background: #ffffff !important;
    box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.1) !important;
    border-radius: 12px !important;
    position: fixed !important;
    .el-popper__arrow::before {
        display: none;
    }
}
</style>

<style lang="scss" scoped>
$main-color: var(--home-main-color);
.header-top-container-bg {
    width: 100%;
    height: 3px;
    background-image: linear-gradient(to right, var(--home-header-line-lighter), var(--home-header-line));
    position: fixed;
    right: 0;
    top: 0px;
    z-index: 999;
}
.header-top-container {
    position: fixed;
    right: 0;
    top: 3px;
    z-index: 999;
    background-color: #fff;
    box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.12);

    .content-wrap {
        height: 50px;
    }
    .left-container {
        display: flex;
        align-items: center;
        white-space: nowrap;
        .name {
            max-width: 280px;
        }
        .mr-20 {
            margin-right: 20px;
        }
    }
    .right-container {
        display: flex;
        align-items: center;
        .right-login {
            color: $main-color;
        }
        .news-img-wrap {
            position: relative;
            width: 22px;
            height: 22px;
            background-image: url('~@/assets/img/gateway/news@2x.png');
            background-repeat: no-repeat;
            background-position: center;
            background-size: 100% 100%;
            .has-message {
                position: absolute;
                right: -4px;
                top: -4px;
                width: 16px;
                height: 16px;
                border-radius: 50%;
                text-align: center;
                line-height: 16px;
                background: #ff4a4a;
                font-size: 10px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #ffffff;
                 transform: scale(0.8);
            }
        }
        .user-img {
            width: 30px;
            height: 30px;
            border-radius: 50%;
        }
        .user-name {
            margin-left: 6px;
            font-size: 14px;
            color: #000000;
        }
        .nav-item {
            margin-left: 33px;
            display: flex;
            align-items: center;
            &::after {
                content: '';
                background: url(~@/assets/img/login/head-down.png) no-repeat;
                width: 10px;
                height: 10px;
                background-size: contain;
                margin-left: 6px;
                display: inline-block;
            }
            &:focus {
                outline: none;
            }
        }
    }
}
.drop-menu-wrap {
    width: 150px;
}
</style>
